import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  CashSpecialIcon,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { REQUEST_ROUTES, TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";

/**
 * Request intro. First visit keeps a single start CTA. Returning shows the
 * welcome-back title plus history and compose. Gallery navigation is plain
 * `useNavigate` (no link token).
 */
export const LandingPage = memo(({ returning = false }: { returning?: boolean }) => {
  const { t } = useTranslation("request");
  const { theme } = useStore();
  const navigate = useNavigate();

  const colorConfig = theme.whiteView;
  const {
    background,
    backgroundBtn,
    textColorBtn,
    bodyCopy,
    dropzoneColors,
    backgroundIcon,
  } = colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <CashSpecialIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container landing-container--tight">
            <div className={returning ? "landing-returning-title" : undefined}>
              <PageTitle
                highlight={
                  returning ? t("landing.returningGreeting") : t("landing.greeting")
                }
                highlightColor={TITLE_COLOR}
                secudnary={t("landing.subtitle")}
                secudnaryColor={TITLE_COLOR}
              />
            </div>
            <BodyCopy textColor={bodyCopy}>{t("landing.body")}</BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          {returning ? (
            <section className="fund-request-actions fund-request-actions--stack">
              <Button
                type="button"
                size="large"
                variant="outline"
                background={backgroundBtn}
                color={TITLE_COLOR}
                style={{ backgroundColor: background }}
                onClick={() => navigate(REQUEST_ROUTES.HOME)}
              >
                {t("transactions.title")}
              </Button>
              <Button
                size="large"
                background={backgroundBtn}
                color={textColorBtn}
                onClick={() => navigate(REQUEST_ROUTES.TRANSFER)}
              >
                {t("transactions.newRequest")}
              </Button>
            </section>
          ) : (
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={() => navigate(REQUEST_ROUTES.HOME)}
            >
              {t("landing.cta")}
            </Button>
          )}
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});

export const LandingReturningPage = () => <LandingPage returning />;
